import script from "./MegaMenuSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./MegaMenuSetup.vue?vue&type=script&setup=true&lang=js"

import "./MegaMenuSetup.vue?vue&type=style&index=0&id=633a6332&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-633a6332"]])

export default __exports__